module.exports = __webpack_public_path__ + "img/aej1n-66wvl.022.4fa7886c.png";